import { Injectable } from '@angular/core';
import { Store } from '@fc-core/store-utils/store';

export interface FilesUploadUiState {
  showUploads: boolean;
}

const initialState: FilesUploadUiState = {
  showUploads: false,
};

@Injectable({ providedIn: 'root' })
export class FilesUploadUiStore extends Store<FilesUploadUiState> {
  constructor() {
    super(initialState);
  }

  showUploads(): void {
    this.update({ showUploads: true });
  }

  hideUploads(): void {
    this.update({ showUploads: false });
  }

  toggleUploads(): void {
    this.update({ showUploads: !this.selectors.showUploads() });
  }
}
